let c = !1;
function i(e) {
  c = e;
}
function l() {
  return c;
}
function g(e, {
  enabled: u = !1,
  onTime: s,
  message: a
}) {
  return u ? (console.log(a), e.constructor.name === "AsyncFunction" ? (async (...n) => {
    const r = performance.now(), t = await e(...n), o = performance.now();
    return s({ timeMs: o - r }), t;
  }) : ((...n) => {
    const r = performance.now(), t = e(...n), o = performance.now();
    return s({ timeMs: o - r }), t;
  })) : e;
}
export {
  l as isQueryLoggingEnabled,
  g as measureExecutionTime,
  i as setQueryLoggingEnabled
};
